import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-document-item-taxes',
  templateUrl: './document-item-taxes.component.html',
  styleUrls: ['./document-item-taxes.component.css'],
})
export class DocumentItemTaxesComponent implements OnInit {
  @Input() fGroup: FormGroup;
  @Input() classTax: string;

  constructor() {}

  ngOnInit() {}

  get fArray() {
    return this.fGroup.controls._documentItemTaxes as FormArray;
  }
}
